export default "__VITE_ASSET__BrRv8IPI__"